'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { formatMoney } from '@/shared/lib/string/formatMoney';
import type { AppointmentsData, IMedcenter } from '@/entities/medcenter/model/types';
interface Props {
  medcenter: IMedcenter;
}
export const DoctorPriceInline: React.FC<Props> = ({
  medcenter
}) => {
  const t = useTranslations('doctor.price');
  const renderPrice = (appointmentType: AppointmentsData) => {
    const {
      price,
      priceWithDiscount
    } = appointmentType;
    if (!price && price !== 0) return <span className="text-sm text-gray-400">{`${t('no_price')}`}</span>;
    if (priceWithDiscount && price) {
      return <div className="lg:flex lg:items-end">
          <span className="block w-max text-sm font-medium">
            {t('price_wrapper', {
            price: formatMoney(priceWithDiscount)
          })}
          </span>
          <span className="text-extra-xs text-statusError md:text-xs">
            <del>{formatMoney(price)} ₸</del>
          </span>
        </div>;
    }
    if (price) {
      return <span className="w-max text-sm font-medium">{t('price_wrapper', {
          price: formatMoney(price)
        })}</span>;
    } else if (price === 0) {
      return <span className="w-max text-sm font-medium">{t('free', {
          price: formatMoney(price)
        })}</span>;
    }
  };
  return <div className="mt-2 flex flex-col gap-2" data-sentry-component="DoctorPriceInline" data-sentry-source-file="DoctorPriceInline.tsx">
      <div className="flex items-start gap-2 md:items-center md:gap-6">
        <div className="flex flex-col justify-start gap-1">
          <p className="text-extra-xs text-textSecondary md:text-xs">{t('primary')}</p>
          {renderPrice(medcenter.appointments.primary)}
        </div>

        <div className="h-7 w-px bg-bgSecondary"></div>

        <div className="flex flex-col justify-start gap-1">
          <p className="text-extra-xs text-textSecondary md:text-xs">{t('secondary')}</p>
          {renderPrice(medcenter.appointments.secondary)}
        </div>

        <div className="h-7 w-px bg-bgSecondary"></div>

        <div className="flex flex-col justify-start gap-1">
          <p className="text-extra-xs text-textSecondary md:text-xs">{t('online')}</p>
          {renderPrice(medcenter.appointments.online)}
        </div>
      </div>

      <p className="text-extra-xs">{t('description')}</p>
    </div>;
};